import { makeAutoObservable, runInAction } from "mobx";
import { RDate } from "../core";
import { ASAPFulfillmentTime, OnTimeFulfillmentTime, } from "../ordering/FulfillmentTime";
import { FI_STORAGE_KEY, } from "./FulfillmentInstructionSerialization";
export class FulfillmentInstructionsStorageManager {
    constructor(data) {
        this.data = data;
        makeAutoObservable(this);
    }
    store() {
        if (this.data.type === "QrWaiter") {
            return;
        }
        const fulfillmentInstructionsData = {
            fulfillmentTime: this.data.fulfillmentTime !== null
                ? this.data.fulfillmentTime.type === "ASAP"
                    ? {
                        type: "ASAP",
                        label: this.data.fulfillmentTime.label,
                    }
                    : {
                        type: "OnTime",
                        label: this.data.fulfillmentTime.label,
                        date: this.data.fulfillmentTime.date.toString,
                        tz: this.data.fulfillmentTime.date.tz,
                    }
                : null,
        };
        const fulfilmentInstructionsDataString = JSON.stringify(fulfillmentInstructionsData);
        localStorage.setItem(FI_STORAGE_KEY, fulfilmentInstructionsDataString);
    }
    // TODO: check availability based on payload (preorder settings) and restaurant fulfillmentTimes / opening hours
    restore() {
        const fulfilmentInstructionsDataString = localStorage.getItem(FI_STORAGE_KEY);
        if (fulfilmentInstructionsDataString === null) {
            return;
        }
        const fulfilmentInstructionsData = JSON.parse(fulfilmentInstructionsDataString);
        runInAction(() => {
            if (this.data.type === "QrWaiter") {
                return;
            }
            if (fulfilmentInstructionsData.fulfillmentTime) {
                this.data.fulfillmentTime =
                    fulfilmentInstructionsData.fulfillmentTime.type === "ASAP"
                        ? new ASAPFulfillmentTime(fulfilmentInstructionsData.fulfillmentTime.label)
                        : new OnTimeFulfillmentTime({
                            date: RDate.fromString(fulfilmentInstructionsData.fulfillmentTime.date, fulfilmentInstructionsData.fulfillmentTime.tz),
                            label: fulfilmentInstructionsData.fulfillmentTime.label,
                        });
            }
        });
    }
}
